import { createSlice } from "@reduxjs/toolkit"

const initialState = {
    filters: {
        search: '',
        selectedStatuses: [],
    }, // e.g., { search: '', category: '', date: '' }
}

const filterSlice = createSlice({
    name: "filter",
    initialState,
    reducers: {
        setFilter: (state, action) => {
            const { key, value } = action.payload
            state.filters[key] = value
        },
        resetFilters: (state) => {
            state.filters = { ...initialState.filters }
        },
    },
})

export const { setFilter, resetFilters } = filterSlice.actions
export default filterSlice.reducer
